class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('cartDrawer');
    this.init();
  }

  init() {
    this.updateETA();
    this.updateBonusProgress();

    // Listen for cart updates
    document.addEventListener('cart:updated', () => {
      this.refresh();
    });

    // Update ETA every minute
    setInterval(() => this.updateETA(), 60000);
  }

  open() {
    if (this.drawer) {
      this.drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.refresh();
    }
  }

  close() {
    if (this.drawer) {
      this.drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  async refresh() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      this.updateCartUI(cart);
      this.updateBonusProgress(cart);
      this.updateETA();
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
  }

  updateCartUI(cart) {
    // Update subtotal
    const subtotalEl = document.getElementById('cartSubtotal');
    if (subtotalEl && cart) {
      subtotalEl.textContent = this.formatMoney(cart.total_price);
    }

    // Update item count in header (if you have one)
    const cartCountEls = document.querySelectorAll('[data-cart-count]');
    if (cart) {
      cartCountEls.forEach(el => {
        el.textContent = cart.item_count;
      });
    }
  }

  updateETA() {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();

    // Check if it's after 17:00 (5 PM)
    const isAfterCutoff = currentHour > 17 || (currentHour === 17 && currentMinute > 0);

    const etaMessage = document.getElementById('etaMessage');
    const etaDetail = document.getElementById('etaDetail');

    if (!etaMessage || !etaDetail) return;

    if (isAfterCutoff) {
      etaMessage.textContent = '2 iş günü içinde gönderilecek';
      etaDetail.textContent = 'Sipariş kesim saati (17:00) geçti';
    } else {
      etaMessage.textContent = 'Ertesi iş günü gönderilecek';
      const hoursLeft = 16 - currentHour;
      const minutesLeft = 60 - currentMinute;
      etaDetail.textContent = `Bugün sipariş vermek için ${hoursLeft} saat ${minutesLeft} dakika kaldı`;
    }
  }

  updateBonusProgress(cart = null) {
    const fetchCart = async () => {
      if (!cart) {
        const response = await fetch('/cart.js');
        cart = await response.json();
      }
      return cart;
    };

    fetchCart().then(cartData => {
      // Count paid items (exclude free items)
      let paidItemCount = 0;
      if (cartData && cartData.items) {
        cartData.items.forEach(item => {
          if (!item.properties || !item.properties._free_extra) {
            paidItemCount += item.quantity;
          }
        });
      }

      const freeItemCount = Math.floor(paidItemCount / 10);
      const progress = (paidItemCount % 10) / 10 * 100;
      const remaining = 10 - (paidItemCount % 10);

      const progressFill = document.getElementById('bonusProgressFill');
      const progressText = document.getElementById('bonusProgressText');

      if (progressFill) {
        progressFill.style.width = `${progress}%`;
      }

      if (progressText) {
        if (freeItemCount > 0) {
          progressText.innerHTML = `🎉 <strong>${freeItemCount} adet hediye</strong> kazandınız! `;
          if (remaining < 10) {
            progressText.innerHTML += `${remaining} ürün daha ekleyin, bir hediye daha kazanın!`;
          }
        } else {
          progressText.textContent = `${remaining} ürün daha ekleyin, 1 hediye kazanın! 🎁`;
        }
      }
    });
  }

  async updateQuantity(lineKey, newQuantity) {
    if (newQuantity < 1) {
      return this.removeItem(lineKey);
    }

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: newQuantity
        })
      });

      if (!response.ok) {
        throw new Error('Miktar güncellenemedi');
      }

      const cart = await response.json();
      this.updateCartUI(cart);
      this.updateBonusProgress(cart);

      // Trigger event
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

      // Reload the page to refresh cart drawer content
      window.location.reload();

    } catch (error) {
      console.error('Update quantity error:', error);
      alert('Miktar güncellenirken bir hata oluştu');
    }
  }

  async removeItem(lineKey) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0
        })
      });

      if (!response.ok) {
        throw new Error('Ürün kaldırılamadı');
      }

      const cart = await response.json();
      this.updateCartUI(cart);
      this.updateBonusProgress(cart);

      // Trigger event
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

      // Reload the page to refresh cart drawer content
      window.location.reload();

    } catch (error) {
      console.error('Remove item error:', error);
      alert('Ürün kaldırılırken bir hata oluştu');
    }
  }

  formatMoney(cents) {
    const amount = cents / 100;
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 2
    }).format(amount);
  }
}

// Initialize cart drawer
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.cartDrawer = new CartDrawer();
  });
} else {
  window.cartDrawer = new CartDrawer();
}

// Helper function to open cart drawer from anywhere
window.openCart = function() {
  if (window.cartDrawer) {
    window.cartDrawer.open();
  }
};

// Intercept add to cart buttons to open drawer
document.addEventListener('click', function(e) {
  const addToCartBtn = e.target.closest('[data-add-to-cart]');
  if (addToCartBtn) {
    e.preventDefault();
    // Add to cart logic here, then open drawer
    setTimeout(() => {
      if (window.cartDrawer) {
        window.cartDrawer.open();
      }
    }, 500);
  }
});
